export default (state, getter, rootState) => val => {
    switch (rootState.finances.pay.form.PaymentDirection) {
        case 0:
            return val.inp > 0 ? val.inp : 0;
        case 1:
            return val.out > 0 ? val.out : 0;
    }
}